<nav
    class="bg-shs-gray-5 w-[52px] h-[calc(100vh-70px)] flex flex-col justify-between items-center fixed top-[70px] left-0 pb-[49px]"
>
    <div class="flex flex-col">
        @for (item of items; track $index) { @if (showItem(item)) {
        <div
            sag-ui-tooltip
            [tooltip]="item.tooltip"
            [routerLink]="item.routerLink"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!border-l-shs-orange"
            tooltipPosition="right"
            class="border-l-[3px] border-l-transparent w-[52px] h-[52px] hover:bg-shs-gray-4 flex items-center justify-center cursor-pointer"
        >
            <span class="icon-{{ item.icon }} text-shs-white-1 text-lg"></span>
        </div>
        } }
    </div>
    <div class="flex flex-col border-t border-shs-gray-4">
        @for (item of bottomItems; track $index) { @if (showItem(item)) {
        <a href="{{ item.routerLink }}" [ariaLabel]="item.ariaLabel" target="_blank">
            <div
                sag-ui-tooltip
                [tooltip]="item.tooltip"
                tooltipPosition="right"
                class="border-l-[3px] border-l-transparent w-[52px] h-[52px] hover:bg-shs-gray-4 flex items-center justify-center cursor-pointer"
            >
                <span class="icon-{{ item.icon }} text-shs-white-1 text-lg"></span>
            </div>
        </a>
        } }
    </div>
</nav>
